module.exports = __webpack_public_path__ + "assets/box-gif-16ddf3d4.svga";